import React, { useState, useRef, useEffect } from 'react'
import {
  Box,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Paper,
  Accordion,
  AccordionSummary,
  Grid,
  Autocomplete,
  TextField,
  AccordionDetails,
  Chip,
  Stack,
  Tooltip,
  Badge,
  ListItemAvatar,
  Avatar,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'
import ListIcon from '@mui/icons-material/List'
import { CloudUpload, Delete } from '@mui/icons-material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { getRequest, postRequest } from '../../globalhelper/helper'
import moment from 'moment'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../redux/Common/commonActions'
import DialougeBox from '../VR2_Form_Rendering/DialougeBox'
import DescriptionIcon from '@mui/icons-material/Description'

export default function Invoice_Reconcilation_Upload() {
  const inputRefs = useRef({})
  const [files, setFiles] = useState({})
  const [formData, setFormData] = useState({
    company: '',
    fromDate: '',
    toDate: '',
    vendorid: ''
  })
  const [companyName, setCompanyName] = useState([])
  const [companyDetails, setCompanyDetails] = useState([])
  const [showListFiles, setShowListFiles] = useState(false)
  const inputRef = useRef()
  const [isDragging, setIsDragging] = useState({})
  const [TransactionTypes, setTransactionTypes] = useState([])
  const [dialougeBox, setDialougeBox] = useState(null)
  const [selectedFiles, setSelectedFiles] = useState([])
  const [selectedFilesType, setSelectedFilesType] = useState('')
  const [vendorDetails, setVendorDetails] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  useEffect(() => {
    getRequest(`api/upload/getCompanyAndVendors`)
      .then(response => {
        console.log(response.res.data)
        const responseData = JSON.parse(response.res.data)
        const orgname = [...new Set(responseData.map(item => item.orgname))]
        setCompanyDetails(
          responseData
            .map(data => ({
              orgname: data.orgname,
              orgid: data.orgid
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.orgid === value.orgid && obj.orgname === value.orgname
                )
            ) || []
        )
        setVendorDetails(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            ) || []
        )
        console.log(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            ) || []
        )
        setVendorDetails(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            )
        )

        setCompanyName(orgname)
        if (orgname.length === 1) {
          setFormData(prev => {
            return { ...prev, company: orgname[0] }
          })
        }
      })
      .catch(err => console.log(err))
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFormData(prev => {
      return { ...prev, fromDate: firstDay, toDate: lastDay }
    })
  }, [])

  useEffect(() => {
    if (formData.company !== '' && formData.company !== null) getTransType()
  }, [formData.company])

  const handleListFiles = type => {
    setSelectedFiles(files?.[type])
    setShowListFiles(true)
    setSelectedFilesType(type)
  }

  const getTransType = async () => {
    try {
      const id = companyDetails.filter(
        item => item.orgname === formData.company
      )

      const companyid = id.map(item => item.orgid)
      let response = await getRequest(
        `api/upload/getTransTypeForAPRU?orgid=${companyid}`
      )
      let parsedData = JSON.parse(response.res.data)
      setTransactionTypes(JSON.parse(response.res.data))
      parsedData?.forEach(data => {
        setFiles(prev => ({
          ...prev,
          [data]: null
        }))
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleReset = () => {
    setFormData({
      company: '',
      vendorid: ''
    })
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    TransactionTypes?.forEach(type => {
      if (inputRef.current && inputRef.current[type]) {
        inputRef.current[type].value = ''
      }
      setFiles(prev => ({
        ...prev,
        [type]: null
      }))
    })
    setFormData(prev => {
      return { ...prev, fromDate: firstDay, toDate: lastDay }
    })
  }

  const handleFileSelect = (event, name) => {
    setDisableBtn(false)
    const newFiles = Array.from(event.target.files)
    setFiles(prev => ({
      ...prev,
      [name]: [...(prev[name] || []), ...newFiles] // Safe array spreading
    }))
    console.log(name)
  }

  const handleDelete = (TransName, filename) => {
    setFiles(prev => {
      const updatedFiles = { ...prev }

      if (updatedFiles[TransName]) {
        updatedFiles[TransName] = updatedFiles[TransName].filter(
          file => file.name !== filename
        )
      }

      return updatedFiles
    })

    setSelectedFiles(prev => prev.filter(name => name !== filename))
  }

  useEffect(() => {
    if (files[selectedFilesType]?.length === 0) {
      if (inputRef.current && inputRef.current[selectedFilesType]) {
        inputRef.current[selectedFilesType].value = ''
      }
      setSelectedFilesType('')
      setShowListFiles(false)
      setShowListFiles(false)
    }
  }, [selectedFiles])

  const handleClear = name => {
    setDialougeBox(
      <DialougeBox
        status={'warning'}
        message={`Are you sure to delete All the selected ${name} Files`}
        operation={() => {
          setFiles(prev => ({ ...prev, [name]: [] }))
          if (inputRef.current && inputRef.current[name]) {
            inputRef.current[name].value = ''
          }
          setDialougeBox(null)
        }}
        onClose={() => setDialougeBox(null)}
      />
    )
  }

  const handleChange = (name, value) => {
    setFormData(prev => {
      return { ...prev, [name]: value }
    })
  }

  const handleDrop = (event, type) => {
    setDisableBtn(false)
    event.preventDefault()
    setIsDragging({ ...isDragging, [type]: false })
    const droppedFiles = Array.from(event.dataTransfer.files)
    setFiles(prev => ({
      ...prev,
      [type]: [...(prev[type] || []), ...droppedFiles]
    }))
  }

  const handleDragOver = (event, type) => {
    event.preventDefault()
    setIsDragging({ ...isDragging, [type]: true }) // Set drag state to true
  }

  const handleDragLeave = (event, type) => {
    event.preventDefault()
    setIsDragging({ ...isDragging, [type]: false }) // Reset when drag leaves
  }

  const handleUpload = async () => {
    try {
      setDisableBtn(true)
      TransactionTypes?.forEach(async (type, index) => {
        if (Array.isArray(files?.[type]) && files?.[type]?.length !== 0) {
          console.log(type, files?.[type])

          const id = companyDetails.filter(
            item => item.orgname === formData.company
          )

          const vendorname = vendorDetails.filter(
            item => item.vendorid === formData.vendorid
          )?.[0]?.vendorname
          const companyid = id.map(item => item.orgid)

          let APIformData = new FormData()
          APIformData.append('ForPrdFrom', formData.fromDate || '')
          APIformData.append('ForPrdTo', formData.toDate || '')
          APIformData.append('VendorID', formData.vendorid || '')
          APIformData.append('VendorName', vendorname || '')
          APIformData.append('OrgID', companyid || '')
          APIformData.append('TransType', type || '')
          Array.from(files?.[type]).forEach(file => {
            APIformData.append('files', file)
          })

          let response = await postRequest(
            `api/upload/UploadInvoiceReconcilation?KEY=InvoiceReconcilationUpload/${companyid}/${type}/${formData.vendorid}`,
            APIformData,
            1200000
          )
          console.log(response);

          if (response.res.status === 'success') {
            if (inputRef.current && inputRef.current[type]) {
              inputRef.current[type].value = ''
            }
            setFiles(prev => ({
              ...prev,
              [type]: null
            }))
          }
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {dialougeBox}
      <Dialog
        open={showListFiles}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{`List of Selected ${selectedFilesType}`}</DialogTitle>
        <DialogContent id='alert-dialog-description'>
          <>
            {files?.[selectedFilesType]?.map(file => (
              <List
                dense={true}
                sx={{
                  maxWidth: '30vw',
                  minWidth: '30vw',
                  maxWidth: '70vh',
                  minWidth: '70vh'
                }}
              >
                <ListItem
                  secondaryAction={
                    <IconButton
                      onClick={() => handleDelete(selectedFilesType, file.name)}
                      edge='end'
                      aria-label='delete'
                    >
                      <Delete />
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Avatar>
                      <DescriptionIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={file?.name}
                    secondary={`${(file?.size / 1024).toFixed(2)} KB`}
                  />
                </ListItem>
                <Divider variant='inset' component='li' />
              </List>
            ))}
          </>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => {
              setSelectedFilesType('')
              setShowListFiles(false)
            }}
            color='error'
            variant='contained'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>
            Please select the date range to view Reports
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xl={3}>
              <Autocomplete
                options={companyName || []}
                value={formData.company || ''}
                onChange={(e, newValue) => handleChange('company', newValue)}
                fullWidth
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company Name'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Autocomplete
                options={vendorDetails || []}
                value={
                  formData.vendorid
                    ? vendorDetails.find(v => v.vendorid === formData.vendorid)
                    : null
                }
                onChange={(e, newValue) =>
                  handleChange('vendorid', newValue ? newValue.vendorid : '')
                }
                fullWidth
                getOptionLabel={option => option?.vendorname || ''}
                isOptionEqualToValue={(option, value) =>
                  option.vendorid === value.vendorid
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor Name'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdFrom'
                  value={formData.fromDate}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    handleChange('fromDate', newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdTo'
                  value={formData.toDate}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    handleChange('toDate', newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xl={1}>
              <Button
                variant='contained'
                color='success'
                disabled={
                  !formData.company ||
                  !formData.vendorid ||
                  !formData.toDate ||
                  !formData.fromDate ||
                  !files ||
                  Object.values(files).every(
                    arr => !arr?.length || arr?.length === 0 || null
                  ) ||
                  disableBtn
                }
                onClick={handleUpload}
              >
                Upload
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                variant='contained'
                color='error'
                onClick={handleReset}
                style={{ marginLeft: '10px' }}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Grid container spacing={3}>
        {TransactionTypes.map(type => (
          <>
            <Grid item xs={4}>
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  textAlign: 'center',
                  borderColor: 'primary.main',
                  backgroundColor: 'grey.50',
                  cursor: 'pointer',
                  position: 'relative',
                  transition:
                    'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  [`&:hover, &.dragging-${type}`]: {
                    transform: 'scale(1.03)',
                    boxShadow: 8,
                    backgroundColor: 'grey.100',
                    zIndex: 1,
                    borderColor: 'primary.main'
                  }
                }}
                className={isDragging?.[type] ? `dragging-${type}` : ''}
                onDrop={e => handleDrop(e, type)}
                onDragOver={e => handleDragOver(e, type)}
                onDragLeave={e => handleDragLeave(e, type)}
                onClick={() => inputRefs.current[type]?.click()}
              >
                <CloudUpload sx={{ fontSize: 40, color: 'primary.main' }} />
                <Typography variant='h6' sx={{ mb: 1 }}>
                  Upload {type} Files
                </Typography>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  sx={{ mb: 2 }}
                >
                  Drag & drop files here, or click to browse
                </Typography>

                <input
                  ref={el => (inputRefs.current[type] = el)}
                  hidden
                  multiple
                  type='file'
                  onChange={e => handleFileSelect(e, type)}
                />

                {files?.[type]?.length > 0 && (
                  <Stack
                    direction='row'
                    spacing={1}
                    sx={{
                      justifyContent: 'center',
                      mt: 2,
                      position: 'absolute',
                      top: 0,
                      right: 0
                    }}
                    onClick={e => e.stopPropagation()} // This prevents the click from bubbling up to Paper
                  >
                    <Tooltip title='Selected files'>
                      <Badge
                        badgeContent={files?.[type]?.length}
                        color='primary'
                      >
                        <IconButton
                          variant='text'
                          color='primary'
                          onClick={e => {
                            e.stopPropagation()
                            handleListFiles(type)
                          }}
                        >
                          <ListIcon />
                        </IconButton>
                      </Badge>
                    </Tooltip>

                    <Tooltip title='Clear selected files'>
                      <IconButton
                        variant='text'
                        edge='end'
                        disabled={!files?.[type]?.length} // Simplified condition
                        color='error'
                        onClick={e => {
                          e.stopPropagation()
                          handleClear(type)
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                )}
              </Paper>
            </Grid>
          </>
        ))}
      </Grid>
    </>
  )
}
